import React from "react";

const EnabledFeaturesContext = React.createContext([]);

export default EnabledFeaturesContext;
